import { UserSettings } from '@payer-admin-ui/components-v2/src/types/settings';
import { wrappedApiGet, wrappedApiPost, wrappedApiPut } from 'utils/http';

export const userSettingsAPI = {
  getUserSettings: (): Promise<UserSettings> => {
    return wrappedApiGet<UserSettings>('/settings', {
      query: { app: 'MERCHANT_UI' },
    }).withObjectResponse();
  },

  saveUserSettings: (settings: UserSettings): Promise<void> => {
    const { isLoaded, ...settingsWithoutIsLoaded } = settings;
    return wrappedApiPost('/settings', {
      body: { ...settingsWithoutIsLoaded, app: 'MERCHANT_UI' },
    }).withEmptyResponse();
  },

  setEmail: (email: string): Promise<void> => {
    return wrappedApiPut('/clients/me/email', {
      body: { email },
    }).withEmptyResponse();
  },
};
